import { api } from "./api"
import type { AnyObject } from "yup"
import type { WithId, components } from "./generated"

/**
 * `memberPool` and `members.profile` are populated to `{ _id, name }` name references
 * by the `getActiveGroupsAndMembers` controller.
 */
type NameRef = { _id: string; name: string }
type ActiveMember = { _id: string; hasGroupRoles?: string[]; profile: NameRef }
type ActiveGroup = Omit<WithId<components["schemas"]["Group"]>, "members"> & { members: ActiveMember[] }
type ActiveRootGroup = Omit<WithId<components["schemas"]["RootGroup"]>, "members" | "memberPool"> & {
	members: ActiveMember[]
	memberPool: NameRef[]
}
type ActiveGroupsResponse = { rootGroup: ActiveRootGroup | null; groups: ActiveGroup[] }

const accessApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getActiveGroups: builder.query<ActiveGroupsResponse, AnyObject | void>({
			query: () => "/access/activeGroups",
			providesTags: ["RootGroup", "Group"],
		}),
	}),
})

export const { useGetActiveGroupsQuery } = accessApi
